import React from 'react'

// CardCurrencyBrandIntroACDC returns an introduction for the ACDC card brand currency table.
// CardCurrencyBrandIntroACDC takes no input.

const BrandedLimitedReleaseIntro = () => {
  return (
    <>
      <p>
        Select the <strong>Branded currency table</strong> and scroll or use the
        search bar to review the supported currencies:
      </p>
    </>
  )
}

export default BrandedLimitedReleaseIntro
